module.exports = __webpack_public_path__ + "static/img/zhutiziNew.5f0a5e98.png";